// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const constants = {
    button: {
        rounded: 3,
    },
    header: {
        breakPoints: {
            md: 1268,
        },
        secondaryNavigation: {
            height: 32,
            heightInCMSMode: 80,
        },
        notification: {
            height: 46,
        },
        sticky: {
            height: 85.5,
        },
        desktop: {
            height: 115,
        },
        tablet: {
            height: 80,
        },
        mobile: {
            height: 155,
        },
    },
    xngPopup: {
        desktopPadding: 20,
        mobilePadding: 10,
    },
    eventBus: {
        mainNavigation: {
            key: "mainNavigation_events",
            types: {
                hideMenu: "mainNavigation_hideMenu",
            },
        },
        updatePoNumberAndJobField: {
            key: "checkout_updatePoNumberAndJobField_events",
            types: {
                poNumber: "poNumber",
                job: "job",
            },
        },
    },
    cookies: {
        hiddenNotificationHeader: "hiddenNotificationHeader",
    },
};
